<template>
  <v-container class='white--text grid-list-lg Início Login'>
    <v-layout align-center justify-center row wrap>
      <v-flex xs12 mt5 text-xs-center></v-flex>
    </v-layout>

    <v-layout align-center justify-center row wrap h100 mt5>
      <div class='center-box'>
        <v-flex class='login-box'>
          <h1 class='logo'>
            <img src='@/assets/img/logo-super-comics.png' v-if="$store.getters.lang === 'pt_BR'" alt='Logo' />
            <img src='@/assets/img/logo-super-comics-global.png' v-else alt='Logo' />
            <p style='font-weight:300; font-size: 0.9em;' v-html="$t('text.accessWithPartner')"></p>
            <img :src='`${partnerData.thumbnailUrl}`' alt='Parceiro' />
          </h1>
        </v-flex>

        <v-flex class='card pt-3 pb-3 pl-3 pr-3 text-center login-box-card' ref='card'>
          <header>
            <h1>{{ $t('title.accessWithData') }}</h1>
          </header>

          <div card>
            <div class='login-box checkmark-wrap'>
              <svg class='checkmark' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 52 52'>
                <circle class='checkmark__circle' cx='26' cy='26' r='25' fill='none' />
                <path class='checkmark__check' fill='none' d='M14.1 27.2l7.1 7.2 16.7-16.8' />
              </svg>
            </div>
          </div>

          <transition name='fade' mode='out-in' tag='v-layout' class='row wrap'>
            <v-flex xs12 key='btnSteps'>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-for='item in fields' :key='item.name'
                    v-if="item.inputType !== 'password'"
                    v-model='item.index'
                    :label='$t(item.label)'
                    v-mask='item.maskPattern.length > 0 ? [...item.maskPattern] : null'
                    :placeholder='item.placeholder'
                    required
                    outlined
                    autocomplete='nope'
                    autofocus
                  ></v-text-field>

                  <v-text-field
                    v-for='item in fields' :key='item.name'
                    v-if="item.inputType === 'password'"
                    type='password'
                    v-model='item.index'
                    :label='$t(item.label)'
                    required
                    outlined
                    autocomplete='nope'
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-btn
                    dark
                    large
                    color='primary'
                    type='submit'
                    @click='handleLogin'
                    :loading='sendingForm'
                  >{{ $t('text.next') }}
                  </v-btn>
                </v-flex>
              </v-layout>

              <v-flex xs12 mt-4>
                <p class='caption mb-0' v-html="$t('text.accessWithPartnerMessage')"></p>
              </v-flex>
            </v-flex>
          </transition>

          <dialog-default
            :show='dialog.show'
            :title='dialog.title'
            :message='dialog.message'
            :ok='dialog.ok'
            v-on:close='dialogClose'
          ></dialog-default>
        </v-flex>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue';
import Vuex from 'vuex';
import VueTheMask from 'vue-the-mask';
import DialogDefault from '@/components/dialog/Default';
import VueCookies from 'vue-cookies';
import axios from 'axios';
import { analytics } from '@/main';

Vue.use(Vuex);
Vue.use(VueCookies);
Vue.use(VueTheMask);

export default {
  components: {
    'dialog-default': DialogDefault
  },
  metaInfo() {
    return {
      title: this.$route.meta.title
        ? 'Super Comics - ' + this.$t(this.$route.meta.title)
        : 'Super Comics'
    };
  },
  data() {
    return {
      dialog: {
        show: false,
        title: '',
        message: '',
        ok: () => {
        }
      },

      fields: this.$route.params.fields,
      partnerData: this.$route.params
    };
  },
  mounted() {
    window.addEventListener('load', function(e) {
      e.preventDefault();
      window.history.back();
    });
  },
  methods: {
    dialogClose() {
      this.dialog.show = false;
    },
    unmaskItemLogin(item) {
      let value = item.index;

      const allowedTypes = ['cpf', 'cpf/cnpj', 'cnpj', 'cpfcnpj', 'phone', 'phone_ar', 'phone_py'];

      if (allowedTypes.includes(item.inputType.toLowerCase())) {
        value = value.replace(/[^0-9]/g, '');
      }
      return value;
    },
    async handleLogin() {
      if (!this.partnerData) {
        return;
      }

      const idp = this.partnerData.id;
      const password = this.fields[1] ? this.fields[1].index : undefined;
      const login = this.unmaskItemLogin(this.fields[0]);

      let payload = {
        idp,
        flag: this.$cookies.get('isoCode') || 'BR',
        login,
        password
      };

      try {
        this.sendingForm = true;

        const response = await axios.post('/api/login/partners/internal', payload);
        const { token } = response.data;

        if (token) {
          Vue.cookies.set('sctoken', response.data.token, '1m');

          if (sessionStorage.getItem('redirectPath')) {
            let redirect = sessionStorage.getItem('redirectPath');
            this.$router.push(redirect);
            sessionStorage.removeItem('redirectPath');
          } else {
            analytics.logEvent('login_partner', {
              id_user: this.$store.getters.profile.id,
              document: response.data.profile.document,
              name: response.data.profile.name,
              partner_name: this.partnerData.name
            });
            this.$router.push('/');
          }
        }
      } catch (error) {
        this.dialog = {
          show: true,
          title: 'Ops...',
          message: error.response.data.message,
          ok: () => {
            this.dialog.show = false;
          }
        };
      } finally {
        this.sendingForm = false;
      }
    }
  }
};
</script>

<style lang='scss' scoped>
@import '../assets/css/_variables';

.logo {
  width: 40%;
}
</style>
